import { render, staticRenderFns } from "./FilesDuplicatesModal.vue?vue&type=template&id=05ed29f6&"
import script from "./FilesDuplicatesModal.vue?vue&type=script&lang=ts&"
export * from "./FilesDuplicatesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports